import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const Collapse = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 20 20">
    <path d="M13.825 4.50831L12.6417 3.33331L10 5.97498L7.35838 3.33331L6.17505 4.50831L10 8.33331M6.17505 15.4916L7.35838 16.6666L10 14.025L12.6417 16.6666L13.8167 15.4916L10 11.6666L6.17505 15.4916Z" />
  </SvgIcon>
));

Collapse.displayName = 'Collapse';

export default Collapse;
